<template>
  <div class="animated fadeIn" v-bind:style="{width: width}">
    <template>
      <!--<div role="tablist">-->
        <!--<template v-for="(data, i) in accordionHeader">-->
          <!--<b-card no-body class="mb-1">-->
            <!--<b-card-header header-tag="header" class="p-1" role="tab">-->
              <!--<b-button block href="#" v-b-toggle="'accordion-' + i" variant="info" style="text-align: left">-->
                <!--{{data.name}} : {{data.total}}-->
              <!--</b-button>-->
            <!--</b-card-header>-->
            <!--<b-collapse :id="'accordion-' + i" visible accordion="my-accordion" role="tabpanel">-->
              <!--<b-card-body>-->
               <!--{{text}}-->
              <!--</b-card-body>-->
            <!--</b-collapse>-->
          <!--</b-card>-->
        <!--</template>-->
      <!--</div>-->

      <div>
        <b-card no-body>
          <b-tabs pills card vertical>
            <template v-for="(dataHeader, indeks) in accordionHeader">
              <template v-if="indeks == 0">
                <b-tab :title="dataHeader.name + ':' + dataHeader.total" active>
                  <customer-detailby-status :dataAccount="detailCustomer"></customer-detailby-status>

                  <!--<table class="table table-bordered">-->
                    <!--<thead>-->
                      <!--<tr>-->
                        <!--<th>No</th>-->
                        <!--<th>Customer Name</th>-->
                        <!--<th>Address</th>-->
                        <!--<th>Activation Date</th>-->
                        <!--<th>Unregister Date</th>-->
                      <!--</tr>-->
                    <!--</thead>-->
                    <!--<tbody>-->
                      <!--<tr v-for="(data,i) in detailCustomer">-->
                        <!--<td>{{i + 1}}</td>-->
                        <!--<td>{{data.cust_acc_name}}</td>-->
                        <!--<td>{{data.installation_address}}-->
                          <!--<br><strong>Register :</strong>{{data.cust_reg_date}}-->
                        <!--</td>-->
                        <!--<td>{{data.cust_activation_date}}</td>-->
                        <!--<td>{{data.cust_unreg_date | notShown}}</td>-->
                      <!--</tr>-->
                    <!--</tbody>-->
                  <!--</table>-->
                </b-tab>
              </template>
              <template v-else>
                <b-tab :title="dataHeader.name + ':' + dataHeader.total">

                  <template v-if="indeks == 3">
                    <customer-detailby-status :dataAccount="detailCustomer" :status="'activationperiode'"></customer-detailby-status>
                  </template>
                  <template v-else-if="indeks == 1">
                    <customer-detailby-status :dataAccount="detailCustomer" :status="'active'"></customer-detailby-status>
                  </template>
                  <template v-else-if="indeks == 2">
                    <customer-detailby-status :dataAccount="detailCustomer" :status="'non-active'"></customer-detailby-status>
                  </template>
                  <template v-else-if="indeks == 4">
                    <customer-detailby-status :dataAccount="detailCustomer" :status="'closeInPeriode'" />
                  </template>
                </b-tab>
              </template>
            </template>
          </b-tabs>
        </b-card>
      </div>
    </template>
  </div>
</template>
<script>
  import {getService} from "../../services";
  import CustomerDetailbyStatus from "./detail/CustomerDetailbyStatus"
  export default{
    components: {
      CustomerDetailbyStatus
    },
    props:{
      width: {
        type: String,
        default: '100%'
      },
      vendor: {
        type: String,
        default: ''
      },
      year: {
        type: String,
        default: ''
      },
      month: {
        type: String,
        default: ''
      },
      branch: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        accordionHeader: [],
        detailCustomer: []
      }
    },
    created: function() {
     this.getTotalCustomerInVendor(this.vendor, this.year, this.month, this.branch)
    },
    methods: {
      createData(key, data) {
        const detail = {
          'name': key,
          'total': data
        }
        return detail
      },
      async getTotalCustomerInVendor(vendor, year, month, branch) {
        try {
          await getService.list_vendor_total(vendor, year, month, branch)
            .then( data=> {
              let total = ''
              let dataAccordion  = []
              this.detailCustomer = data.data
              let activeNcloseInSamePeriode = 0
              for (let j = 0; j < data.data.length; j++) {
                if (data.data[j].active && data.data[j].close_on_periode) {
                  activeNcloseInSamePeriode++;
                }
              }
              for (let i in data) {
                if (data.hasOwnProperty(i)) {
                  if (i == 'total') {
                    dataAccordion.push(this.createData('Total Customer', data[i]))
                  } else if (i == 'total_active') {
                    dataAccordion.push(this.createData('Total Active', data[i]))
                  } else if (i == 'total_close_on_periode') {
                    dataAccordion.push(this.createData('Total Close In Periode', data[i]))
                  } else if (i == 'total_non_active') {
                    if (activeNcloseInSamePeriode > 0) {
                       total = data[i] + '+' + activeNcloseInSamePeriode
                    }else {
                      total = data[i]
                    }
                    dataAccordion.push(this.createData('Total Non Active', total))
                  } else if ( i == 'total_reg_on_periode') {
                    dataAccordion.push(this.createData ('Total Activation In Periode', data[i]))
                  }
                }
              }
              this.accordionHeader = dataAccordion
            })
        } catch (error) {

        }
      }
    }
  }
</script>
